<app-banner [banner]="cookiesPolicyPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>

<div class="container mt-5 templatePage mb-5">
  <div [innerHTML]="cookiesPolicyPage.body | mdToHtml"></div>

  <div id="ot-sdk-cookie-policy"></div>
</div>
